import { useGoogleOneTapLogin } from "@react-oauth/google";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import { PROXY } from "../lib/utils";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";

const GoogleOneTap = () => {
  const { googleLoginSuccess, authState } = useAuth();
  const location = useLocation();

  const isLoginPage = location.pathname === "/login";

  useGoogleOneTapLogin({
    disabled: !!authState.accessToken || isLoginPage,

    onSuccess: async (credentialResponse) => {
      console.log("✅ One-Tap onSuccess fired", credentialResponse);

      try {
        const res = await axios.post(
          `${PROXY}/auth/google`,
          { credential: credentialResponse.credential },
          { withCredentials: true }
        );

        console.log("✅ Backend /auth/google response", res.data);
        toast.success("Google login success ✅");

        googleLoginSuccess(res.data.accessToken, res.data.user);
      } catch (err) {
        console.error(
          "❌ Backend /auth/google failed",
          err?.response?.data || err.message
        );
        toast.error(err?.response?.data?.message || "Google login failed");
      }
    },

    onError: () => {
      console.warn("⚠️ One-Tap onError fired (not shown/blocked)");
      toast.warn("One-Tap not shown / blocked");
    },

    cancel_on_tap_outside: false,
  });

  return null;
};

export default GoogleOneTap;
